module.exports = __webpack_public_path__ + "img/c-1.43069f48.png";